<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-check', fontSet: 'fad'}"
	[headerText]="
		data.wasAborted
			? (T.JOIN_TRAINING_RECORDING_STOPPED_DIALOG_REC_ABORTED | translate)
			: (T.JOIN_TRAINING_RECORDING_STOPPED_DIALOG_REC_FINISHED | translate)
	"
	[matDialogData]="data"
	[rect]="rect"
	[showClosingX]="false"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		@if (data.wasAborted) {
			{{ T.JOIN_TRAINING_RECORDING_STOPPED_DIALOG_REC_ABORTED | translate }}
		}

		@if (!data.wasAborted) {
			{{ T.JOIN_TRAINING_RECORDING_STOPPED_DIALOG_REC_FINISHED | translate }}
			{{ isLastRun ? (T.JOIN_TRAINING_LAST_RUN | translate) : (T.JOIN_TRAINING_STOP_DIALOG_MORE_RUNS | translate) }}
		}
	</ng-container>

	<ng-container actions>
		@if (!data.wasAborted && clientProperties().isTablet) {
			<a
				(click)="startDebriefing()"
				[class.disabled]="!data.scenarioRecording.isReadyForArchive"
				class="clickable"
				style="margin-right: auto"
				>{{ T.JOIN_TRAINING_GO_TO_DEBRIEFING | translate }}
				@if (!data.scenarioRecording.isReadyForArchive) {
					-
					<span class="loadingText" style="font-size: smaller">{{
						T.PRO_RECORDING_DIALOG_PROCESSING_RECORDING | translate
					}}</span>
				}
			</a>
		}
		<button color="accent" mat-flat-button routerLink="/event-dashboard">{{ T.BACK_TO_DASHBOARD | translate }}</button>
	</ng-container>
</sim-basic-material-dialog>
